import { render, staticRenderFns } from "./MemberProfileDialog.vue?vue&type=template&id=0dddd5e1&scoped=true"
import script from "./MemberProfileDialog.vue?vue&type=script&lang=js"
export * from "./MemberProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./MemberProfileDialog.vue?vue&type=style&index=0&id=0dddd5e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dddd5e1",
  null
  
)

export default component.exports